
import jwt_decode from 'jwt-decode';
import CONFIG from '../common/config.json'
const USER_INFO_URI = CONFIG.API_PROD_URL.SIGN_IN;
export const parseCredential = (credential) => {
	return {
		id_token: credential
		// expires_at: decoded.exp,
		// expires_in: tokenObj.expires_in,
		// first_issued_at: decoded.iat
	};
}

export const AUTH_TOKEN_KEY = 'authToken';
const MS_PER_SECOND = 1000;

// Hard cap on how long the silent-refresh chain may keep a session alive:
// 7 days after the first sign-in the user is logged out and must sign in again
export const SESSION_MAX_AGE_MS = 7 * 24 * 60 * 60 * MS_PER_SECOND;

// The 7-day window starts at the first sign-in and is NOT extended by silent
// refreshes. Credentials stored before session_started_at existed fall back
// to the token's issued-at claim.
export const msUntilSessionMaxAge = (credential) => {
	const startedAt =
		credential.session_started_at ??
		jwt_decode(credential.id_token).iat * MS_PER_SECOND;
	return startedAt + SESSION_MAX_AGE_MS - new Date().getTime();
};

export const getSessionCredential = () => {
	const dataJson = localStorage.getItem(AUTH_TOKEN_KEY);
	if (!dataJson) return undefined;
	try {
		const credential = JSON.parse(dataJson);
		const decoded = jwt_decode(credential.id_token);
		// A token that expired since the last visit goes straight back to
		// the login screen, where One Tap auto_select re-signs in instantly
		if (decoded.exp * MS_PER_SECOND <= new Date().getTime()) {
			localStorage.removeItem(AUTH_TOKEN_KEY);
			return undefined;
		}
		// Past the 7-day cap the stored session is dead no matter how fresh
		// the last silent refresh was
		if (msUntilSessionMaxAge(credential) <= 0) {
			localStorage.removeItem(AUTH_TOKEN_KEY);
			return undefined;
		}
		return credential;
	} catch (e) {
		// A corrupt or legacy credential must not white-screen the app —
		// drop it and start over from the login screen
		localStorage.removeItem(AUTH_TOKEN_KEY);
		return undefined;
	}
};

export const storeSessionCredential = (credential) => {
	const enriched = {
		...credential,
		session_started_at: getStoredSessionStartedAt() ?? new Date().getTime(),
	};
	localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(enriched));
	return enriched;
};

// A silent refresh overwrites the stored credential but must not restart
// the 7-day window, so the original sign-in time is carried over
const getStoredSessionStartedAt = () => {
	try {
		return JSON.parse(localStorage.getItem(AUTH_TOKEN_KEY))?.session_started_at;
	} catch (e) {
		return undefined;
	}
};


export const clearAuthetication = (reload) => {
	console.log("clearAuthetication")
	localStorage.removeItem(AUTH_TOKEN_KEY);
	// credential left over from the sessionStorage era
	sessionStorage.removeItem(AUTH_TOKEN_KEY);
	if (reload) window.location.reload();
};


export const fetchUserInfo = async (credentials) => {
	const response = await fetch(USER_INFO_URI, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'api-auth-token': credentials.id_token
		},
	});
	if (!response.ok) {
		throw new Error(`User info request failed with status ${response.status}`);
	}
	const userInfo = await response.json();
	if (!userInfo?.data) {
		throw new Error('User info response has no data');
	}
	return userInfo.data;
};
